import React from 'react'
import MoviePosterCdn from './MoviePosterCdn'

const OttImageComponent = ({ ottPlatform, handleImageClick }) => (
  <img
    src={MoviePosterCdn(ottPlatform)}
    onClick={handleImageClick}
    height='50'
    width='50'
  />
)

export default OttImageComponent
